<template>
  <v-tooltip
    :bottom="!top"
    content-class=""
    open-delay="250"
    :top="top">
    <template v-slot:activator="{ on }">
      <div
        class="disabled-tooltip-block"
        :class="block_class"
        v-on="condition ? on : ''"
        @click.capture="click">
        <slot
          name="activator"
          :on="on"/>
      </div>
    </template>
    <div
      v-if="condition"
      class="disabled-tooltip-info"
      :class="tooltip_class">
      {{ tooltip_text }}
    </div>
  </v-tooltip>
</template>
<script>
export default {
  name: 'disabledTooltip',
  props: {
    tooltip_text: String,
    tooltip_class: String,
    block_class: String,
    condition: Boolean,
    top: Boolean,
    prevent: Boolean
  },
  methods: {
    click(ev) {
      if ( this.prevent ) {
        ev.stopPropagation()
      }
    },
  }
}
</script>
<style lang="scss">
.disabled-tooltip-info {
  color: 2px solid var(--v-secondary__red-base) ;
  max-width: 400px;
}
</style>
